import { ACTIONS, USERTYPES } from "../../../constants/Constants";
import { encrypt } from "../../../helpers/AESUtility";
import { encryptData } from "../../../helpers/RSAUtility";
import { addRadiologist, addUser, editRadiologist, editUser } from "../../../service/UserService";

export const submitUserData = async (state, values, checkFirmNew, firmId, firmList, userData, userType, selectedModalityForFirm, selectedModalityWithSubModality, checkAllFirm) => {
  console.log("Values in submitUserData ", values)
  console.log(checkFirmNew);
  const encryptedFirstName = encryptData(values.firstName);
  const encryptedLastName = encryptData(values.lastName);
  const encryptedEmail = encryptData(values.email);
  const encryptedMobile = encryptData(values.mobile);
  const encryptedUsername = encryptData(values.username);
  const encryptedPassword = encryptData(values.password);
  const encryptedConfirmPassword = encryptData(values.confirmPassword);
  const encryptedAction = encryptData(values.action);
  const role = encryptData(userType);

  let modalityIdList = [];
  let technicianContactList = [];
  let response;

      if (
        userType === USERTYPES.ADMIN ||
        userType === USERTYPES.FIRMADMIN
      ) {
        //USER DTO FOR ADD
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            enableLlmReport: values.enableLlmReport ? 1 : 0,
            role,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureDto.signatureImage != null ? values.signatureDto.signatureImage : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            // technicianContactList: userData?.user?.technicianContactList
            technicianContactList: values.technicianContactList,
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator,
            passwordResetAllowed:values.isPasswordResetAllowed

          };

                    response = await addUser(userDto,firmId);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            enableLlmReport: values.enableLlmReport ? 1 : 0,

            role,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureDto.signatureImage != null ? values.signatureDto.signatureImage : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            // technicianContactList: userData?.user?.technicianContactList
            technicianContactList: values.technicianContactList,
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator,
            passwordResetAllowed:values.isPasswordResetAllowed
          };

          response = await editUser(userDto,firmId);
        }
      } else if (userType === USERTYPES.SUPERVISOR) {
        //USER DTO FOR ADD
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            role,
            firmIdListNew: checkFirmNew,
            showRadiologistTime: values.showRadiologistTime,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            qcSupervisor: values.qcSupervisor ? 1: 0,
            keyImage: values.keyImage ? 1: 0,
            qcSaveReport: values.qcSaveReport ? 1: 0,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator
           
          };
          console.log(userDto)
          response = await addUser(userDto,firmId);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            accountNonLocked : values.accountNonLocked,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            capacity: userData.user.capacity,
            role,
            firmIdListNew: checkFirmNew,
            showRadiologistTime: values.showRadiologistTime,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            qcSupervisor: values.qcSupervisor ? 1: 0,
            keyImage: values.keyImage ? 1: 0,
            qcSaveReport: values.qcSaveReport ? 1: 0,
            allhospitalAccess: userData.user.allhospitalAccess,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            showWord: values.showWord ? 1 : 0,
            peerReviewAdmin:values.isPeerReviewAdmin,
            peerReviewEvaluator:values.isPeerReviewEvaluator
          };

          response = await editUser(userDto,firmId);
        }
      } else if (
        userType === USERTYPES.FIRMDOCTOR ||
        userType === USERTYPES.FIRMTECHNICIAN
      ) {
        //USER DTO FOR ADD
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            technicianContactList: values.technicianContactList != null ? values.technicianContactList : [],
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            accountNonLocked : values.accountNonLocked,
          };

          response = await addUser(userDto,firmId);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            capacity: userData.user.capacity,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmId: firmId,
              firmRequired: true,
            },
            signatureDto: {
              signatureRequired: false,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            technicianContactList : values.technicianContactList != null ? values.technicianContactList : [],
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            accountNonLocked : values.accountNonLocked,
          };

          response = await editUser(userDto,firmId);
        }
      } else if(userType === USERTYPES.RADIOLOGIST) {

        modalityIdList.push(values.firstModalityPreference);
        modalityIdList.push(values.secondModalityPreference);
        modalityIdList.push(values.thirdModalityPreference);
        
        if (state.action === ACTIONS.ADD) {
          const userDto = {
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            qcRadiologist: values.qcRadiologist ? 1 : 0,
            capacity: values.capacity,
            showAllStudies: values.showAllStudies ? 1 : 0,
            disableSubmit: values.disableSubmit,
            sendAssignMail: values.sendAssignMail ? 1 : 0,
            checkCapacityOnManualAssign: values.checkCapacityOnManualAssign ? 1 : 0,
            onPayroll: values.onPayroll,
            uploadStudy: values.uploadStudy,
            addQCRadiologist: false,
            radiologistType: values.radiologistType,
            allhospitalAccess: checkAllFirm ? 1 : 0,
            radiologistProvider: userData.radiologistProvider,
            role,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmRequired: false,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            // signatureDto: {
            //   signatureRequired: true,
            //   signatureText: values.signatureText,
            //   signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
            //   isSignatureImageDeleted: values.signatureDto.isSignatureImageDeleted ? 1 : 0
            // },
            signatureDto: {
              signatureRequired: true,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },

            modalityIdList: modalityIdList.filter((modality) => String(modality)),
            pediatricSpecialist: values.pediatricSpecialist ? 1 : 0,
            selectedPediatricModalityId: values.selectedPediatricModalityId,
            enableTypistWorkflow: values.enableTypistWorkflow? 1:0,
            showWord: values.showWord ? 1 : 0,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            accountNonLocked : values.accountNonLocked,
            enableLlmReport : values.enableLlmReport ? 1 : 0,
          };
          response = await addRadiologist(userDto, userDto.signatureDto.signatureImage);
        }
        //USER DTO FOR EDIT
        else if (state.action === ACTIONS.EDIT) {
          const userDto = {
            id: values.id,
            username: encryptedUsername,
            password: encryptedPassword,
            confirmPassword: encryptedConfirmPassword,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            qcRadiologist: values.qcRadiologist ? 1 : 0,
            capacity: values.capacity,
            showAllStudies: values.showAllStudies ? 1 : 0,
            disableSubmit: values.disableSubmit,
            sendAssignMail: values.sendAssignMail ? 1 : 0,
            checkCapacityOnManualAssign: values.checkCapacityOnManualAssign ? 1 : 0,
            onPayroll: values.onPayroll,
            uploadStudy: values.uploadStudy,
            radiologistType: values.radiologistType,
            allhospitalAccess: checkAllFirm ? 1 : 0,
            radiologistProvider: userData.radiologistProvider,
            role,
            firmIdListNew: checkFirmNew,
            userFirmDto: {
              firmRequired: false,
            },
            selectedModalityForFirm: selectedModalityForFirm.filter((mod) => String(mod)),
            modalityWithSubModalityPreferences:selectedModalityWithSubModality,
            signatureDto: {
              signatureRequired: userData.user.signatureDto.signatureRequired,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
              signatureImageUrl : values.signatureDto.signatureImageUrl
            },
            modalityIdList: modalityIdList.filter((modality) => String(modality)),
            pediatricSpecialist: values.pediatricSpecialist ? 1 : 0,
            selectedPediatricModalityId: values.selectedPediatricModalityId,
            enableTypistWorkflow: values.enableTypistWorkflow? 1:0,
            showWord: values.showWord ? 1 : 0,
            twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
            enableLlmReport : values.enableLlmReport ? 1 : 0,
            accountNonLocked : values.accountNonLocked,
          };

          response = await editRadiologist(userDto, userDto.signatureDto.signatureImage);
      }
    }else if (
      userType === USERTYPES.TYPIST
    ) {
      //USER DTO FOR ADD
      if (state.action === ACTIONS.ADD) {
        const userDto = {
          username: encryptedUsername,
          password: encryptedPassword,
          confirmPassword: encryptedConfirmPassword,
          firstName: encryptedFirstName,
          lastName: encryptedLastName,
          email: encryptedEmail,
          mobile: encryptedMobile,
          action: encryptedAction,
          active: values.active,
          role,
          firmIdListNew: checkFirmNew,
          userFirmDto: {
            firmId: firmId,
            firmRequired: true,
          },
          signatureDto: {
            signatureRequired: false,
            signatureText: values.signatureText,
            signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
            isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            signatureImageUrl : values.signatureDto.signatureImageUrl
          },
          showWord: values.showWord,
          twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
          accountNonLocked : values.accountNonLocked,
        };

        response = await addUser(userDto,firmId);
      }
      //USER DTO FOR EDIT
      else if (state.action === ACTIONS.EDIT) {
        const userDto = {
          id: values.id,
          username: encryptedUsername,
          firstName: encryptedFirstName,
          lastName: encryptedLastName,
          email: encryptedEmail,
          mobile: encryptedMobile,
          action: encryptedAction,
          active: values.active,
          role,
          capacity: userData.user.capacity,
          firmIdListNew: checkFirmNew,
          userFirmDto: {
            firmId: firmId,
            firmRequired: true,
          },
          signatureDto: {
            signatureRequired: false,
            signatureText: values.signatureText,
            signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
            isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            signatureImageUrl : values.signatureDto.signatureImageUrl
          },
          showWord: values.showWord,
          twoFactorEnabled : values.twoFactorEnabled ? 1: 0,
          accountNonLocked : values.accountNonLocked,
        };

        response = await editUser(userDto,firmId);
      }
    }
    return response;
};

export const submitUserProfileData = async (loggedInUserRole, values, profileData) => {
  console.log(loggedInUserRole)
  console.log(values)
  console.log(profileData)
  const encryptedFirstName = encryptData(values.firstName);
  const encryptedLastName = encryptData(values.lastName);
  const encryptedEmail = encryptData(values.email);
  const encryptedMobile = encryptData(values.mobile);
  const encryptedUsername = encryptData(values.username);
  const encryptedAction = encryptData(values.action);
  const role = encryptData(loggedInUserRole);

  let response;

      if (
        loggedInUserRole === USERTYPES.ADMIN ||
        loggedInUserRole === USERTYPES.FIRMADMIN
      ) {
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            technicianContactList: values?.technicianContactList
          };

          response = await editUser(userDto);

      } else if (loggedInUserRole === USERTYPES.SUPERVISOR) {
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            //capacity: 10,
            role,
            showRadiologistTime: values.showRadiologistTime,
            qcSupervisor: profileData.qcSupervisor,
            qcSaveReport: profileData.qcSaveReport,
            showConfirmation: values.showConfirmation,
            signatureDto: {
              signatureRequired: false,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            keyImage:profileData.keyImage,
          };
          
          response = await editUser(userDto);
        
      } else if (
        loggedInUserRole === USERTYPES.FIRMDOCTOR ||
        loggedInUserRole === USERTYPES.FIRMTECHNICIAN
      ) {
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
            role,
            //capacity: 10,
            // userFirmDto: {
            //   firmId: firmId,
            //   firmRequired: true,
            // },
            signatureDto: {
              signatureRequired: false,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            technicianContactList: values?.technicianContactList
          };
          
          response = await editUser(userDto);
        
      } else if(loggedInUserRole === USERTYPES.RADIOLOGIST) {
        // modalityIdList.push(values.firstModalityPreference);
        // modalityIdList.push(values.secondModalityPreference);
        // modalityIdList.push(values.thirdModalityPreference);
        // console.log(modalityIdList)
          const userDto = {
            id: profileData.id,
            username: encryptedUsername,
            firstName: encryptedFirstName,
            lastName: encryptedLastName,
            email: encryptedEmail,
            mobile: encryptedMobile,
            action: encryptedAction,
            active: values.active,
          
            //qcRadiologist: values.qcRadiologist ? 1 : 0,
            //showAllStudies: values.showAllStudies ? 1 : 0,
            sendAssignMail: values.sendAssignMail ? 1 : 0,
            checkCapacityOnManualAssign: values.checkCapacityOnManualAssign ? 1 : 0,
            //onPayroll: values.onPayroll,
            radiologistType: profileData.radiologistType,
            allhospitalAccess: profileData.allhospitalAccess,
            //radiologistProvider: userData.radiologistProvider,
            role,
            //firmIdList: checkFirm.filter((firm) => String(firm)),
            userFirmDto: {
              firmRequired: false,
            },
            signatureDto: {
              signatureRequired: profileData.signatureDto.signatureRequired,
              signatureText: values.signatureText,
              signatureImage: values.signatureImage != null ? values.signatureImage[0] : null,
              isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            },
            capacity:profileData.capacity,
            modalityIdList:profileData.modalityIdList,
            enableTypistWorkflow: values.enableTypistWorkflow,
            // showWord: values.showWord ? 1 : 0
          };
          console.log(userDto)
          response = await editRadiologist(userDto, userDto.signatureDto.signatureImage);
      
    }
    else if (
      loggedInUserRole === USERTYPES.TYPIST
    ) {
        const userDto = {
          id: profileData.id,
          username: encryptedUsername,
          firstName: encryptedFirstName,
          lastName: encryptedLastName,
          email: encryptedEmail,
          mobile: encryptedMobile,
          action: encryptedAction,
          active: values.active,
          role,
          signatureDto: {
            signatureRequired: false,
            isSignatureImageDeleted: values?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
          },
        };
        
        response = await editUser(userDto);
      
    }
    return response;
};